import { MenuItem } from "@mui/material";
import { useState } from "react";
import { getTranslateByKey } from "@/main/services/utils";
import { useThreeDotsClaimContext } from "../contex";
import CardGridQuote from "@/main/screens/claim/searchClaim/components/CardGridQuote/CardGridQuote";
import { useAutomaticActionReducer } from "@/main/store/automaticAction";
import { AutomaticActionEnum } from "@/main/services/enum/AutomaticActionEnum";

export interface IThreeDotsClaimGenerateProcurementProps {
	guidClaim: string;
	claimNumber: string;
	guidBillingAddress: string;
	showGenerateButton: boolean;
	refreshClaim: () => void;
	refreshClaimCounts: () => void;
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

function ThreeDotsClaimGenerateProcurement(props: IThreeDotsClaimGenerateProcurementProps) {
	const { closeThreeDotsClaim, generateIdMenu } = useThreeDotsClaimContext();
	const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
	const { automaticAction } = useAutomaticActionReducer();

	const hasAutomaticGenerationPending =
		automaticAction.data?.some(
			(x) => x.idAction === AutomaticActionEnum.GenerateOrderBySaveBuyerPartAsnwerByClaim && x.id === props.guidClaim,
		) ?? false;

	function handleClick() {
		setIsOpenModal(true);
		closeThreeDotsClaim();
	}
	function closeModal() {
		setIsOpenModal(false);
	}

	if (!props.showGenerateButton && !hasAutomaticGenerationPending) return null;

	return (
		<>
			{props.showGenerateButton && (
				<MenuItem id={generateIdMenu("generate")} onClick={handleClick}>
					{getTranslateByKey("information.generateOrder")}
				</MenuItem>
			)}

			<CardGridQuote
				guidClaim={props.guidClaim}
				claimNumber={props.claimNumber}
				guidBillingAddress={props.guidBillingAddress}
				refreshClaim={props.refreshClaim}
				refreshClaimCounts={props.refreshClaimCounts}
				isOpenModal={isOpenModal}
				closeModal={closeModal}
				setIsOpenModal={setIsOpenModal}
				setIsLoading={props.setIsLoading}
			/>
		</>
	);
}

export { ThreeDotsClaimGenerateProcurement };
